import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  public Results: any[] = [];
  public toSearchFor: string;

  constructor(
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.toSearchFor = params.q || null;
      !!this.toSearchFor && this.doSearch();
    });
  }

  ngOnInit(): void {
  }

  public doSearch() {
    console.debug(this.toSearchFor);
  }

}
